interface StatCardProps {
  label: string;
  value: string | number;
  icon?: string;
}

const ICON_GRADIENTS = [
  'from-blue-500/20 to-violet-500/20',
  'from-teal-500/20 to-cyan-500/20',
  'from-amber-500/20 to-orange-500/20',
  'from-pink-500/20 to-rose-500/20',
];

export default function StatCard({ label, value, icon }: StatCardProps) {
  // Derive a stable gradient index from the label
  const gradientIdx = label.split('').reduce((sum, c) => sum + c.charCodeAt(0), 0) % ICON_GRADIENTS.length;

  return (
    <div className="flex items-center gap-4 rounded-2xl border border-slate-200/70 bg-white p-6 shadow-[0_1px_2px_rgba(15,23,42,0.06),0_1px_1px_rgba(15,23,42,0.04)] dark:border-white/10 dark:bg-card-dark">
      {icon && (
        <span className={`flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br ${ICON_GRADIENTS[gradientIdx]} text-2xl`} aria-hidden="true">
          {icon}
        </span>
      )}
      <div>
        <p className="text-sm font-medium text-slate-500 dark:text-slate-400">{label}</p>
        <p className="font-mono text-2xl font-bold text-slate-900 dark:text-white">{value}</p>
      </div>
    </div>
  );
}
